// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ee0w","icon":"styles_icon__3dUTX"};